import { render } from "./DialogSwz.vue?vue&type=template&id=381bf628"
import script from "./DialogSwz.vue?vue&type=script&lang=js"
export * from "./DialogSwz.vue?vue&type=script&lang=js"

import "./DialogSwz.vue?vue&type=style&index=0&id=381bf628&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__